import { message } from 'antd'
import { downloadLink } from 'helpers/download-file'
import { useCallback, useRef, useState } from 'react'
import { getCensusTemplateDownloadUrl } from '../api/census-enrollment-platform-api-client'

const CENSUS_TEMPLATE_FILE_NAME = '2026-Census-Instructions-and-Sample.xltx'

export const useDownloadCensusTemplate = () => {
  const [isLoading, setIsLoading] = useState(false)
  // State updates are async, so a ref is needed to reject a fast double click.
  const isInFlightRef = useRef(false)

  const downloadTemplate = useCallback(async () => {
    if (isInFlightRef.current) return
    isInFlightRef.current = true
    setIsLoading(true)
    message.info(
      'Preparing the census template. The download will start automatically when the file is ready.'
    )
    try {
      const { url } = await getCensusTemplateDownloadUrl()
      downloadLink(url, CENSUS_TEMPLATE_FILE_NAME)
    } catch (error) {
      console.error('Census template download failed:', error)
      message.error('Unable to download the census template. Please try again.')
    } finally {
      isInFlightRef.current = false
      setIsLoading(false)
    }
  }, [])

  return { isLoading, downloadTemplate }
}
